module.exports = __webpack_public_path__ + "static/media/transpak_example2.3042c863.png";